module.exports = __webpack_public_path__ + "static/media/yumyumsauce.3052b338.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/flavor/yumyumsauce.jpg
// module id = 152
// module chunks = 0